import Vue from 'vue'
import Router from 'vue-router'
import NotFound from '@/view/error/NotFound'
import Login from '@/view/login/Login'
import ETCErrorPayDataList from '@/view/login/ETCErrorPayDataList'
import userRootGroupMain from '@/view/user/userRootGroupMain'

// 贡嘎机场定制报表
import uniformedVehicles from '@/view/GungaAirportReport/uniformedVehicles'
import abnormalVehicles from '@/view/GungaAirportReport/abnormalVehicles'
import gGAbnormalVehicles from '@/view/GungaAirportReport/gGAbnormalVehicles'
import tempCarFreeDeparture from '@/view/GungaAirportReport/tempCarFreeDeparture'
import tempCarHandFreeDeparture from '@/view/GungaAirportReport/tempCarHandFreeDeparture'
import monthlyCarDeparture from '@/view/GungaAirportReport/monthlyCarDeparture'
import reconciliationDetail from '@/view/GungaAirportReport/reconciliationDetail'
import unionPaySensorlessPayment from '@/view/GungaAirportReport/unionPaySensorlessPayment'
import weChatAlipayPayment from '@/view/GungaAirportReport/weChatAlipayPayment'
import cashPaymentDetail from '@/view/GungaAirportReport/cashPaymentDetail'

import indexNew from '@/view/home/indexNew'
import indexDetail from '@/view/home/detail'
// index[原首页]
// import index from '@/view/home/index'
// user
import userGroupMain from '@/view/user/userGroupMain'
import userMain from '@/view/user/userMain'
import editUserPwd from '@/view/user/editUserPwd'
import userGroup from '@/view/user/userGroup'
// cust
import custMain from '@/view/cust/custMain'
import custSettingMain from '@/view/cust/custSettingMain'
import custMaintenance from '@/view/cust/custMaintenance'
import custMinProgSet from '@/view/cust/custMinProgSet'
import custGroup from '@/view/cust/custGroup'
import sysInterfaceMain from '@/view/cust/sysInterfaceMain'
import appMain from '@/view/cust/appMain'
import custKey from '@/view/cust/custKey'
import custCardSetUser from '@/view/cust/custCardSetUser'
// device
import deviceMain from '@/view/device/deviceMain'
import parkMonitor from '@/view/device/parkMonitor'
import shra2019 from '@/view/device/shra2019'
import equDvc from '@/view/device/equDvc'
import log from '@/view/device/log'
// import deviceLog from '@/view/device/deviceLog'
import errorLogMain from '@/view/device/errorLogMain'
import mqttStatusMain from '@/view/device/mqttStatusMain'
import cloudLog from '@/view/device/cloudLog'
// channel log
import channelLogMain from '@/view/device/channelLogMain'
import logMain from '@/view/device/logMain'// park
import parkMain from '@/view/park/parkMain'
import payOnline from '@/view/park/payOnline'
import channelMain from '@/view/park/channelMain'
import parkingLockMain from '@/view/park/parkingLockMain'
import parkingGeoMain from '@/view/park/parkingGeoMain'
import parkDevCamMain from '@/view/park/parkDevCamMain'
import ehallCardTimeoutMain from '@/view/park/ehallCardTimeoutMain'
import filterPlateCodeMain from '@/view/park/filterPlateCodeMain'
import paymentLink from '@/view/park/paymentLink'
import seatQrCode from '@/view/park/seatQrCode'
import shappRegister from '@/view/park/shappRegister'
import otherSet from '@/view/park/otherSet'
import lcdLog from '@/view/device/lcdLog'
import gateOperationLog from '@/view/device/gateOperationLog'
import devAccLog from '@/view/device/devAccLog'
import geomagneticMain from '@/view/park/geomagneticMain'
import adTempMain from '@/view/park/adTempMain'
import adTempBizMain from '@/view/park/adTempBizMain'
// road side park
import roadSideParkMain from '@/view/roadSidePark/roadSideParkMain'
import pdaMain from '@/view/roadSidePark/pdaMain'
import departureDataMaintenance from '@/view/roadSidePark/departureDataMaintenance'
import roadSideCarPresentList from '@/view/roadSidePark/report/roadSideCarPresentList'
import outParkForYYB from '@/view/roadSidePark/report/outParkForYYB'
import roadSideCarDepartureList from '@/view/roadSidePark/report/roadSideCarDepartureList'
import rsOutParkHisSum from '@/view/roadSidePark/report/roadSideOutParkHisSum'
import staffPerformanceList from '@/view/roadSidePark/report/staffPerformanceList'
import roadSideHandoverList from '@/view/roadSidePark/report/roadSideHandoverList'
import roadSideCarTurnover from '@/view/roadSidePark/report/roadSideCarTurnover'
import roadSideEInvoiceDataList from '@/view/roadSidePark/report/roadSideEInvoiceDataList'
import parkPlace from '@/view/roadSidePark/parkPlace'
import arrMain from '@/view/roadSidePark/arrMain'
import nbiotMain from '@/view/roadSidePark/nbiotMain'
import ledMain from '@/view/roadSidePark/ledMain'
// rate
import rateMain from '@/view/rate/rateMain'
import holidayMain from '@/view/rate/holidayMain'
import tempRateMain from '@/view/rate/tempRateMain'
// card
import cardMain from '@/view/card/cardMain'
import customizedCardMain from '@/view/card/customizedCardMain'
import cardConcentrateMain from '@/view/card/cardConcentrateMain'
import monthCardMain from '@/view/card/monthCardMain'
import cardGroupMain from '@/view/card/cardGroupMain'
import blackPlateMain from '@/view/card/blackPlateMain'
import cardFeeMain from '@/view/card/cardFeeMain'
import deploymentMain from '@/view/card/deploymentMain'
import parkReserveList from '@/view/card/parkReserveList'
import cardMainHis from '@/view/card/cardMainHis'
import rechargeCardList from '@/view/report/rechargeCardList'
import fuDanEhallCard from '@/view/card/fuDanEhallCard'
import reportingVehicles from '@/view/card/reportingVehicles'
import PlatCardGroup from '@/view/card/PlatCardGroup'
// report
import carPresentList from '@/view/report/carPresentList'
import greenCarPresentList from '@/view/report/greenCarPresentList'
import carDepartureList from '@/view/report/carDepartureList'
import greenCarDepartureList from '@/view/report/greenCarDepartureList'
import carAppselHisList from '@/view/report/carAppselHisList'
import carInList from '@/view/report/carInList'
import carOutList from '@/view/report/carOutList'
import chargeDetailList from '@/view/report/chargeDetailList'
import dailyChargeReport from '@/view/report/dailyChargeReport'
import custChargeReport from '@/view/report/custChargeReport'
import payDataList from '@/view/report/ePayList'
import ePayTodayList from '@/view/report/ePayTodayList'
import payDayDataList from '@/view/report/payDayDataList'
import handoverList from '@/view/report/handoverList'
import epayExceptionList from '@/view/report/epayExceptionList'
import etcPayDataList from '@/view/report/etcPayDataList'
import couponList from '@/view/report/couponList'
import eCashPayList from '@/view/report/eCashPayList'
import redPacketList from '@/view/report/redPacketList'
import couponUsageList from '@/view/report/couponUsageList'
import wYCouponUsageList from '@/view/report/wYCouponUsageList'
import hSCouponUsageList from '@/view/report/hSCouponUsageList'
import bJXCCouponUsageList from '@/view/report/bJXCCouponUsageList'
import paymentDetailsReport from '@/view/report/paymentDetailsReport'
import eInvoiceDataList from '@/view/report/eInvoiceDataList'
import paymentSummary from '@/view/report/paymentSummary'
import paymentSummaryNew from '@/view/report/paymentSummaryNew'
import paymentReconciliation from '@/view/report/paymentReconciliation'

import paymentSummaryOld from '@/view/report/paymentSummaryOld'
import illegalReport from '@/view/report/illegalReport'
import monthlyCardPaymet from '@/view/report/monthlyCardPaymet'
import geomagneticBusMain from '@/view/report/geomagneticBusMain'
import parkChnlVehicles from '@/view/report/parkChnlVehicles'
import parkPlaceList from '@/view/report/parkPlaceList'
import parkPlaceChar from '@/view/report/parkPlaceChar'
import plateCorrectData from '@/view/report/plateCorrectData'

import cardRecByMonth from '@/view/report/unionReport/cardRecByMonth'
import unionCouponPay from '@/view/report/unionReport/couponPay'
import unionPayDetail from '@/view/report/unionReport/payDetail'
import hotelMonthDay from '@/view/report/unionReport/hotelMonthDay'
import hotelDay from '@/view/report/unionReport/hotelDay'
import hotelCouponDay from '@/view/report/unionReport/hotelCouponDay'
import parkingPayDaySum from '@/view/report/unionReport/parkingPayDaySum'
import parkingPayDaySums from '@/view/report/unionReport/parkingPayDaySums'
import parkingPayMonthSum from '@/view/report/unionReport/parkingPayMonthSum'
import recAndCntByGrp from '@/view/report/unionReport/recAndCntByGrp'
import mobDetail from '@/view/report/unionReport/mobDetail'
import mobPassWork from '@/view/report/unionReport/mobPassWork'
import bgMobDetail from '@/view/report/unionReport/bgMobDetail'
import bgChargePreExeReport from '@/view/report/unionReport/bgChargePreExeReport'
import bgMobPassWork from '@/view/report/unionReport/bgMobPassWork'
import bgCardMobDetail from '@/view/report/unionReport/bgCardMobDetail'
import bgCardChargeReport from '@/view/report/unionReport/bgCardChargeReport'
import bgCashPaymentDetail from '@/view/report/unionReport/bgCashPaymentDetail'
import bgDayMobPassWork from '@/view/report/unionReport/bgDayMobPassWork'
import bgMonMobPassWork from '@/view/report/unionReport/bgMonMobPassWork'

// setting
import ISVReg from '@/view/setting/ISVReg'
// aliParking
import aliParkMain from '@/view/aliParking/aliParkMain'
import aliParkPID from '@/view/aliParking/aliParkPID'
// coupon
import sellerGroup from '@/view/coupon/sellerGroup'
import sellerMain from '@/view/coupon/sellerMain'
import couponType from '@/view/coupon/couponType'
import couponBatch from '@/view/coupon/couponBatch'
import couponQCode from '@/view/coupon/couponQCode'
import couponGroup from '@/view/coupon/couponGroup'
import demonstration from '@/view/home/demonstration'
import rechargeCoupon from '@/view/coupon/rechargeCoupon'
import rechargeCouponTemplate from '@/view/coupon/rechargeCouponTemplate'

import eCouponReport from '@/view/report/eCouponReport'
import sCouponReport from '@/view/report/sCouponReport'
import freeTimePlateList from '@/view/report/freeTimePlateList'
import cloudSeatData from '@/view/report/cloudSeatData'
import paymentChannelList from '@/view/report/paymentChannelList'
import couPurPayList from '@/view/report/couPurPayList'
import pasOrOutVehicleStatisticsList from '@/view/report/pasOrOutVehicleStatisticsList'
import shAppUploadList from '@/view/report/shAppUploadList'
import carOffCarResPreList from '@/view/report/carOffCarResPreList'
import carOffEhallCardList from '@/view/report/carOffEhallCardList'
// 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
const originalPush = Router.prototype.push
Router.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}
Vue.use(Router)
export default new Router({
  routes: [
    {
      path: '/indexNew',
      component: indexNew,
      name: 'indexNew',
      meta: {
        keepAlive: true,
        menuId: 'indexNew'
      }
    },
    {
      path: '/log',
      component: log,
      name: 'log',
      meta: {
        keepAlive: true,
        menuId: 'log'
      }
    },
    {
      path: '/rechargeCardList',
      component: rechargeCardList,
      name: 'rechargeCardList',
      meta: {
        keepAlive: true,
        menuId: 'rechargeCardList'
      }
    },
    {
      path: '/rechargeCoupon',
      component: rechargeCoupon,
      name: 'rechargeCoupon',
      meta: {
        keepAlive: true,
        menuId: 'rechargeCoupon'
      }
    },
    {
      path: '/rechargeCouponTemplate',
      component: rechargeCouponTemplate,
      name: 'rechargeCouponTemplate',
      meta: {
        keepAlive: true,
        menuId: 'rechargeCouponTemplate'
      }
    },
    {
      path: '/indexDetail',
      component: indexDetail,
      name: 'indexDetail',
      meta: {
        keepAlive: true,
        menuId: 'indexDetail'
      }
    },
    {
      path: '/',
      component: demonstration,
      name: 'index',
      meta: {
        keepAlive: true,
        menuId: 'index'
      }
    },
    {
      path: '/adTempMain',
      component: adTempMain,
      name: 'adTempMain',
      meta: {
        keepAlive: true,
        menuId: 'adTempMain'
      }
    },
    {
      path: '/freeTimePlateList',
      component: freeTimePlateList,
      name: 'freeTimePlateList',
      meta: {
        keepAlive: true,
        menuId: 'freeTimePlateList'
      }
    },
    {
      path: '/sCouponReport',
      component: sCouponReport,
      name: 'sCouponReport',
      meta: {
        keepAlive: true,
        menuId: 'sCouponReport'
      }
    },
    {
      path: '/sellerGroup',
      component: sellerGroup,
      name: 'sellerGroup',
      meta: {
        keepAlive: true,
        menuId: 'sellerGroup'
      }
    },
    {
      path: '/eCouponReport',
      component: eCouponReport,
      name: 'eCouponReport',
      meta: {
        keepAlive: true,
        menuId: 'eCouponReport'
      }
    },
    {
      path: '/paymentReconciliation',
      component: paymentReconciliation,
      name: 'paymentReconciliation',
      meta: {
        keepAlive: true,
        menuId: 'paymentReconciliation'
      }
    },
    {
      path: '/cashPaymentDetail',
      component: cashPaymentDetail,
      name: 'cashPaymentDetail',
      meta: {
        keepAlive: true,
        menuId: 'cashPaymentDetail'
      }
    },
    {
      path: '/unionPaySensorlessPayment',
      component: unionPaySensorlessPayment,
      name: 'unionPaySensorlessPayment',
      meta: {
        keepAlive: true,
        menuId: 'unionPaySensorlessPayment'
      }
    },
    {
      path: '/weChatAlipayPayment',
      component: weChatAlipayPayment,
      name: 'weChatAlipayPayment',
      meta: {
        keepAlive: true,
        menuId: 'weChatAlipayPayment'
      }
    },
    {
      path: '/reconciliationDetail',
      component: reconciliationDetail,
      name: 'reconciliationDetail',
      meta: {
        keepAlive: true,
        menuId: 'reconciliationDetail'
      }
    },
    {
      path: '/monthlyCarDeparture',
      component: monthlyCarDeparture,
      name: 'monthlyCarDeparture',
      meta: {
        keepAlive: true,
        menuId: 'monthlyCarDeparture'
      }
    },
    {
      path: '/tempCarHandFreeDeparture',
      component: tempCarHandFreeDeparture,
      name: 'tempCarHandFreeDeparture',
      meta: {
        keepAlive: true,
        menuId: 'tempCarHandFreeDeparture'
      }
    },
    {
      path: '/tempCarFreeDeparture',
      component: tempCarFreeDeparture,
      name: 'tempCarFreeDeparture',
      meta: {
        keepAlive: true,
        menuId: 'tempCarFreeDeparture'
      }
    },
    {
      path: '/abnormalVehicles',
      component: abnormalVehicles,
      name: 'abnormalVehicles',
      meta: {
        keepAlive: true,
        menuId: 'abnormalVehicles'
      }
    },
    {
      path: '/gGAbnormalVehicles',
      component: gGAbnormalVehicles,
      name: 'gGAbnormalVehicles',
      meta: {
        keepAlive: true,
        menuId: 'gGAbnormalVehicles'
      }
    },
    {
      path: '/uniformedVehicles',
      component: uniformedVehicles,
      name: 'uniformedVehicles',
      meta: {
        keepAlive: true,
        menuId: 'uniformedVehicles'
      }
    },
    {
      path: '/adTempBizMain',
      component: adTempBizMain,
      name: 'adTempBizMain',
      meta: {
        keepAlive: true,
        menuId: 'adTempBizMain'
      }
    },
    {
      path: '/parkChnlVehicles',
      component: parkChnlVehicles,
      name: 'parkChnlVehicles',
      meta: {
        keepAlive: true,
        menuId: 'parkChnlVehicles'
      }
    },
    {
      path: '/parkPlaceList',
      component: parkPlaceList,
      name: 'parkPlaceList',
      meta: {
        keepAlive: true,
        menuId: 'parkPlaceList'
      }
    },
    {
      path: '/parkPlaceChar',
      component: parkPlaceChar,
      name: 'parkPlaceChar',
      meta: {
        keepAlive: true,
        menuId: 'parkPlaceChar'
      }
    },
    {
      path: '/plateCorrectData',
      component: plateCorrectData,
      name: 'plateCorrectData',
      meta: {
        keepAlive: true,
        menuId: 'plateCorrectData'
      }
    },
    {
      path: '/demonstration',
      component: demonstration,
      name: 'demonstration',
      meta: {
        keepAlive: true,
        menuId: 'demonstration'
      }
    },
    {
      path: '/carAppselHisList',
      component: carAppselHisList,
      name: 'carAppselHisList',
      meta: {
        keepAlive: true,
        menuId: 'carAppselHisList'
      }
    },
    {
      path: '/couponType',
      component: couponType,
      name: 'couponType',
      meta: {
        keepAlive: true,
        menuId: 'coupon/couponType'
      }
    },
    {
      path: '/shra2019',
      component: shra2019,
      name: 'shra2019',
      meta: {
        keepAlive: true,
        menuId: 'device/shra2019'
      }
    },
    {
      path: '/equDvc',
      component: equDvc,
      name: 'equDvc',
      meta: {
        keepAlive: true,
        menuId: 'device/equDvc'
      }
    },
    {
      path: '/couponBatch',
      component: couponBatch,
      name: 'couponBatch',
      meta: {
        keepAlive: true,
        menuId: 'coupon/couponBatch'
      }
    },
    {
      path: '/couponQCode',
      component: couponQCode,
      name: 'couponQCode',
      meta: {
        keepAlive: true,
        menuId: 'coupon/couponQCode'
      }
    },
    {
      path: '/couponGroup',
      component: couponGroup,
      name: 'couponGroup',
      meta: {
        keepAlive: true,
        menuId: 'coupon/couponGroup'
      }
    },
    {
      path: '/sellerMain',
      component: sellerMain,
      name: 'sellerMain',
      meta: {
        keepAlive: true,
        menuId: 'coupon/sellerMain'
      }
    },
    {
      path: '/roadSideCarTurnover',
      component: roadSideCarTurnover,
      name: 'roadSideCarTurnover',
      meta: {
        keepAlive: true,
        menuId: 'roadSidePark/roadSideCarTurnover'
      }
    },
    {
      path: '/epayExceptionList',
      component: epayExceptionList,
      name: 'epayExceptionList',
      meta: {
        keepAlive: true,
        menuId: 'report/epayExceptionList'
      }
    },
    {
      path: '/departureDataMaintenance',
      component: departureDataMaintenance,
      name: 'departureDataMaintenance',
      meta: {
        keepAlive: true,
        menuId: 'roadSidePark/departureDataMaintenance'
      }
    },
    {
      path: '/roadSideHandoverList',
      component: roadSideHandoverList,
      name: 'roadSideHandoverList',
      meta: {
        keepAlive: true,
        menuId: 'roadSidePark/roadSideHandoverList'
      }
    },
    {
      path: '/roadSideCarPresentList',
      component: roadSideCarPresentList,
      name: 'roadSideCarPresentList',
      meta: {
        keepAlive: true,
        menuId: 'roadSidePark/roadSideCarPresentList'
      }
    },
    {
      path: '/outParkForYYB',
      component: outParkForYYB,
      name: 'outParkForYYB',
      meta: {
        keepAlive: true,
        menuId: 'roadSidePark/outParkForYYB'
      }
    },
    {
      path: '/roadSideEInvoiceDataList',
      component: roadSideEInvoiceDataList,
      name: 'roadSideEInvoiceDataList',
      meta: {
        keepAlive: true,
        menuId: 'roadSidePark/roadSideEInvoiceDataList'
      }
    },
    {
      path: '/roadSideCarDepartureList',
      component: roadSideCarDepartureList,
      name: 'roadSideCarDepartureList',
      meta: {
        keepAlive: true,
        menuId: 'roadSidePark/roadSideCarDepartureList'
      }
    },
    {
      path: '/rsOutParkHisSum',
      component: rsOutParkHisSum,
      name: 'rsOutParkHisSum',
      meta: {
        keepAlive: true,
        menuId: 'roadSidePark/rsOutParkHisSum'
      }
    },
    {
      path: '/staffPerformanceList',
      component: staffPerformanceList,
      name: 'staffPerformanceList',
      meta: {
        keepAlive: true,
        menuId: 'roadSidePark/staffPerformanceList'
      }
    },
    {
      path: '/aliParkPID',
      component: aliParkPID,
      name: 'aliParkPID',
      meta: {
        keepAlive: true,
        menuId: 'parkMain/aliParkPID'
      }
    },
    {
      path: '/aliParkMain',
      component: aliParkMain,
      name: 'aliParkMain',
      meta: {
        keepAlive: true,
        menuId: 'parkMain/aliParkMain'
      }
    },
    {
      path: '/eCashPayList',
      component: eCashPayList,
      name: 'eCashPayList',
      meta: {
        keepAlive: true,
        menuId: 'report/eCashPayList'
      }
    },
    {
      path: '/redPacketList',
      component: redPacketList,
      name: 'redPacketList',
      meta: {
        keepAlive: true,
        menuId: 'report/redPacketList'
      }
    },
    {
      path: '/couponUsageList',
      component: couponUsageList,
      name: 'couponUsageList',
      meta: {
        keepAlive: true,
        menuId: 'report/couponUsageList'
      }
    },
    {
      path: '/wYCouponUsageList',
      component: wYCouponUsageList,
      name: 'wYCouponUsageList',
      meta: {
        keepAlive: true,
        menuId: 'report/wYCouponUsageList'
      }
    },
    {
      path: '/hSCouponUsageList',
      component: hSCouponUsageList,
      name: 'hSCouponUsageList',
      meta: {
        keepAlive: true,
        menuId: 'report/hSCouponUsageList'
      }
    },
    {
      path: '/bJXCCouponUsageList',
      component: bJXCCouponUsageList,
      name: 'bJXCCouponUsageList',
      meta: {
        keepAlive: true,
        menuId: 'report/bJXCCouponUsageList'
      }
    },
    {
      path: '/paymentDetailsReport',
      component: paymentDetailsReport,
      name: 'paymentDetailsReport',
      meta: {
        keepAlive: true,
        menuId: 'report/paymentDetailsReport'
      }
    },
    {
      path: '/carOutList',
      component: carOutList,
      name: 'carOutList',
      meta: {
        keepAlive: true,
        menuId: 'report/carOutList'
      }
    },
    {
      path: '/carInList',
      component: carInList,
      name: 'carInList',
      meta: {
        keepAlive: true,
        menuId: 'report/carInList'
      }
    },
    {
      path: '/carDepartureList',
      component: carDepartureList,
      name: 'carDepartureList',
      meta: {
        keepAlive: true,
        menuId: 'report/carDepartureList'
      }
    },
    {
      path: '/greenCarDepartureList',
      component: greenCarDepartureList,
      name: 'greenCarDepartureList',
      meta: {
        keepAlive: true,
        menuId: 'report/greenCarDepartureList'
      }
    },
    {
      path: '/paymentSummary',
      component: paymentSummary,
      name: 'paymentSummary',
      meta: {
        keepAlive: true,
        menuId: 'report/paymentSummary'
      }
    },
    {
      path: '/paymentSummaryNew',
      component: paymentSummaryNew,
      name: 'paymentSummaryNew',
      meta: {
        keepAlive: true,
        menuId: 'report/paymentSummaryNew'
      }
    },
    {
      path: '/paymentSummaryOld',
      component: paymentSummaryOld,
      name: 'paymentSummaryOld',
      meta: {
        keepAlive: true,
        menuId: 'report/paymentSummaryOld'
      }
    },
    {
      path: '/illegalReport',
      component: illegalReport,
      name: 'illegalReport',
      meta: {
        keepAlive: true,
        menuId: 'report/illegalReport'
      }
    },
    {
      path: '/cardRecByMonth',
      component: cardRecByMonth,
      name: 'cardRecByMonth',
      meta: {
        keepAlive: true,
        menuId: 'report/cardRecByMonth'
      }
    },
    {
      path: '/cardRecByMonthZB',
      component: cardRecByMonth,
      name: 'cardRecByMonthZB',
      meta: {
        keepAlive: true,
        menuId: 'report/cardRecByMonthZB'
      }
    },
    {
      path: '/unionCouponPay',
      component: unionCouponPay,
      name: 'unionCouponPay',
      meta: {
        keepAlive: true,
        menuId: 'report/unionCouponPay'
      }
    },
    {
      path: '/unionCouponPayZB',
      component: unionCouponPay,
      name: 'unionCouponPayZB',
      meta: {
        keepAlive: true,
        menuId: 'report/unionCouponPayZB'
      }
    },
    {
      path: '/unionPayDetail',
      component: unionPayDetail,
      name: 'unionPayDetail',
      meta: {
        keepAlive: true,
        menuId: 'report/unionPayDetail'
      }
    },
    {
      path: '/unionPayDetailZB',
      component: unionPayDetail,
      name: 'unionPayDetailZB',
      meta: {
        keepAlive: true,
        menuId: 'report/unionPayDetailZB'
      }
    },
    {
      path: '/mobDetail',
      component: mobDetail,
      name: 'mobDetail',
      meta: {
        keepAlive: true,
        menuId: 'report/mobDetail'
      }
    },
    {
      path: '/mobPassWork',
      component: mobPassWork,
      name: 'mobPassWork',
      meta: {
        keepAlive: true,
        menuId: 'report/mobPassWork'
      }
    },
    {
      path: '/hotelDay',
      component: hotelDay,
      name: 'hotelDay',
      meta: {
        keepAlive: true,
        menuId: 'report/hotelDay'
      }
    },
    {
      path: '/hotelMonthDay',
      component: hotelMonthDay,
      name: 'hotelMonthDay',
      meta: {
        keepAlive: true,
        menuId: 'report/hotelMonthDay'
      }
    },
    {
      path: '/hotelCouponDay',
      component: hotelCouponDay,
      name: 'hotelCouponDay',
      meta: {
        keepAlive: true,
        menuId: 'report/hotelCouponDay'
      }
    },
    {
      path: '/parkingPayDaySum',
      component: parkingPayDaySum,
      name: 'parkingPayDaySum',
      meta: {
        keepAlive: true,
        menuId: 'report/parkingPayDaySum'
      }
    },
    {
      path: '/parkingPayDaySums',
      component: parkingPayDaySums,
      name: 'parkingPayDaySums',
      meta: {
        keepAlive: true,
        menuId: 'report/parkingPayDaySums'
      }
    },
    {
      path: '/parkingPayDaySumZB',
      component: parkingPayDaySum,
      name: 'parkingPayDaySumZB',
      meta: {
        keepAlive: true,
        menuId: 'report/parkingPayDaySumZB'
      }
    },
    {
      path: '/parkingPayMonthSum',
      component: parkingPayMonthSum,
      name: 'parkingPayMonthSum',
      meta: {
        keepAlive: true,
        menuId: 'report/parkingPayMonthSum'
      }
    },
    {
      path: '/parkingPayMonthSumZB',
      component: parkingPayMonthSum,
      name: 'parkingPayMonthSumZB',
      meta: {
        keepAlive: true,
        menuId: 'report/parkingPayMonthSumZB'
      }
    },
    {
      path: '/recAndCntByGrp',
      component: recAndCntByGrp,
      name: 'recAndCntByGrp',
      meta: {
        keepAlive: true,
        menuId: 'report/recAndCntByGrp'
      }
    },
    {
      path: '/recAndCntByGrpZB',
      component: recAndCntByGrp,
      name: 'recAndCntByGrpZB',
      meta: {
        keepAlive: true,
        menuId: 'report/recAndCntByGrpZB'
      }
    },
    {
      path: '/carPresentList',
      component: carPresentList,
      name: 'carPresentList',
      meta: {
        keepAlive: true,
        menuId: 'report/carPresentList'
      }
    },
    {
      path: '/greenCarPresentList',
      component: greenCarPresentList,
      name: 'greenCarPresentList',
      meta: {
        keepAlive: true,
        menuId: 'report/greenCarPresentList'
      }
    },
    {
      path: '/carOffCarResPreList',
      component: carOffCarResPreList,
      name: 'carOffCarResPreList',
      meta: {
        keepAlive: true,
        menuId: 'report/carOffCarResPreList'
      }
    },
    {
      path: '/carOffEhallCardList',
      component: carOffEhallCardList,
      name: 'carOffEhallCardList',
      meta: {
        keepAlive: true,
        menuId: 'report/carOffEhallCardList'
      }
    },
    {
      path: '/dailyChargeReport',
      component: dailyChargeReport,
      name: 'dailyChargeReport',
      meta: {
        keepAlive: true,
        menuId: 'report/dailyChargeReport'
      }
    },
    {
      path: '/chargeDetailList',
      component: chargeDetailList,
      name: 'chargeDetailList',
      meta: {
        keepAlive: true,
        menuId: 'report/chargeDetailList'
      }
    },
    {
      path: '/custChargeReport',
      component: custChargeReport,
      name: 'custChargeReport',
      meta: {
        keepAlive: true,
        menuId: 'report/custChargeReport'
      }
    },
    {
      path: '/etcPayDataList',
      component: etcPayDataList,
      name: 'etcPayDataList',
      meta: {
        keepAlive: true,
        menuId: 'report/etcPayDataList'
      }
    },
    {
      path: '/couponList',
      component: couponList,
      name: 'couponList',
      meta: {
        keepAlive: true,
        menuId: 'report/couponList'
      }
    },
    {
      path: '/payDataList',
      component: payDataList,
      name: 'payDataList',
      meta: {
        keepAlive: true,
        menuId: 'report/payDataList'
      }
    },
    {
      path: '/ePayTodayList',
      component: ePayTodayList,
      name: 'ePayTodayList',
      meta: {
        keepAlive: true,
        menuId: 'report/ePayTodayList'
      }
    },
    {
      path: '/monthlyCardPaymet',
      component: monthlyCardPaymet,
      name: 'monthlyCardPaymet',
      meta: {
        keepAlive: true,
        menuId: 'report/monthlyCardPaymet'
      }
    },
    {
      path: '/geomagneticBusMain',
      component: geomagneticBusMain,
      name: 'geomagneticBusMain',
      meta: {
        keepAlive: true,
        menuId: 'report/geomagneticBusMain'
      }
    },
    {
      path: '/eInvoiceDataList',
      component: eInvoiceDataList,
      name: 'eInvoiceDataList',
      meta: {
        keepAlive: true,
        menuId: 'report/eInvoiceDataList'
      }
    },
    {
      path: '/payDayDataList',
      component: payDayDataList,
      name: 'payDayDataList',
      meta: {
        keepAlive: true,
        menuId: 'report/payDayDataList'
      }
    },
    {
      path: '/paymentLink',
      component: paymentLink,
      name: 'paymentLink',
      meta: {
        keepAlive: true,
        menuId: 'park/paymentLink'
      }
    },
    {
      path: '/seatQrCode',
      component: seatQrCode,
      name: 'seatQrCode',
      meta: {
        keepAlive: true,
        menuId: 'park/seatQrCode'
      }
    },
    {
      path: '/shappRegister',
      component: shappRegister,
      name: 'shappRegister',
      meta: {
        keepAlive: true,
        menuId: 'park/shappRegister'
      }
    },
    {
      path: '/otherSet',
      component: otherSet,
      name: 'otherSet',
      meta: {
        keepAlive: true,
        menuId: 'park/otherSet'
      }
    },
    {
      path: '/geomagneticMain',
      component: geomagneticMain,
      name: 'geomagneticMain',
      meta: {
        keepAlive: true,
        menuId: 'park/geomagneticMain'
      }
    },
    {
      path: '/handoverList',
      component: handoverList,
      name: 'handoverList',
      meta: {
        keepAlive: true,
        menuId: 'report/handoverList'
      }
    },
    // {
    //   path: '/deviceLog',
    //   component: deviceLog,
    //   name: 'deviceLog',
    //   meta: {
    //     keepAlive: true,
    //     menuId: 'device/deviceLog'
    //   }
    // },
    {
      path: '/errorLogMain',
      component: errorLogMain,
      name: 'errorLogMain',
      meta: {
        keepAlive: true,
        menuId: 'device/errorLogMain'
      }
    },
    {
      path: '/channelLogMain',
      component: channelLogMain,
      name: 'channelLogMain',
      meta: {
        keepAlive: true,
        menuId: 'device/channelLogMain'
      }
    },
    {
      path: '/cloudLog',
      component: cloudLog,
      name: 'cloudLog',
      meta: {
        keepAlive: true,
        menuId: 'device/cloudLog'
      }
    },
    {
      path: '/devAccLog',
      component: devAccLog,
      name: 'devAccLog',
      meta: {
        keepAlive: true,
        menuId: 'device/devAccLog'
      }
    },
    {
      path: '/lcdLog',
      component: lcdLog,
      name: 'lcdLog',
      meta: {
        keepAlive: true,
        menuId: 'device/lcdLog'
      }
    },
    {
      path: '/gateOperationLog',
      component: gateOperationLog,
      name: 'gateOperationLog',
      meta: {
        keepAlive: true,
        menuId: 'device/gateOperationLog'
      }
    },
    {
      path: '/deviceMain',
      component: deviceMain,
      name: 'deviceMain',
      meta: {
        keepAlive: true,
        menuId: 'device'
      }
    },
    {
      path: '/parkMonitor',
      component: parkMonitor,
      name: 'parkMonitor',
      meta: {
        keepAlive: true,
        menuId: 'device'
      }
    },
    {
      path: '/logMain',
      component: logMain,
      name: 'logMain',
      meta: {
        keepAlive: true,
        menuId: 'device'
      }
    },
    {
      path: '/mqttStatusMain',
      component: mqttStatusMain,
      name: 'mqttStatusMain',
      meta: {
        keepAlive: true,
        menuId: 'device'
      }
    },
    {
      path: '/custMain',
      component: custMain,
      name: 'custMain',
      meta: {
        keepAlive: true,
        menuId: 'cust'
      }
    },
    {
      path: '/custKey',
      component: custKey,
      name: 'custKey',
      meta: {
        keepAlive: true,
        menuId: 'cust'
      }
    },
    {
      path: '/custCardSetUser',
      component: custCardSetUser,
      name: 'custCardSetUser',
      meta: {
        keepAlive: true,
        menuId: 'cust'
      }
    },
    {
      path: '/custSettingMain',
      component: custSettingMain,
      name: 'custSettingMain',
      meta: {
        keepAlive: true,
        menuId: 'cust'
      }
    },
    {
      path: '/custMaintenance',
      component: custMaintenance,
      name: 'custMaintenance',
      meta: {
        keepAlive: true,
        menuId: 'cust'
      }
    },
    {
      path: '/custMinProgSet',
      component: custMinProgSet,
      name: 'custMinProgSet',
      meta: {
        keepAlive: true,
        menuId: 'cust'
      }
    },
    {
      path: '/custGroup',
      component: custGroup,
      name: 'custGroup',
      meta: {
        keepAlive: true,
        menuId: 'cust'
      }
    },
    {
      path: '/sysInterfaceMain',
      component: sysInterfaceMain,
      name: 'sysInterfaceMain',
      meta: {
        keepAlive: true,
        menuId: 'cust'
      }
    },
    {
      path: '/appMain',
      component: appMain,
      name: 'appMain',
      meta: {
        keepAlive: true,
        menuId: 'cust'
      }
    },
    {
      path: '/userRootGroupMain',
      component: userRootGroupMain,
      name: 'userRootGroupMain',
      meta: {
        keepAlive: true,
        menuId: 'user'
      }
    },
    {
      path: '/userGroup',
      component: userGroup,
      name: 'userGroup',
      meta: {
        keepAlive: true,
        menuId: 'user'
      }
    },
    {
      path: '/userGroupMain',
      component: userGroupMain,
      name: 'userGroupMain',
      meta: {
        keepAlive: true,
        menuId: 'user'
      }
    },
    {
      path: '/userMain',
      component: userMain,
      name: 'userMain',
      meta: {
        keepAlive: true,
        menuId: 'user'
      }
    },
    {
      path: '/editUserPwd',
      component: editUserPwd,
      name: 'editUserPwd',
      meta: {
        keepAlive: true,
        menuId: 'editUserPwd'
      }
    },
    {
      path: '/parkMain',
      component: parkMain,
      name: 'parkMain',
      meta: {
        keepAlive: true,
        menuId: 'parkMain/parkMain'
      }
    },
    {
      path: '/payOnline',
      component: payOnline,
      name: 'payOnline',
      meta: {
        keepAlive: true,
        menuId: 'parkMain/payOnline'
      }
    },
    {
      path: '/channelMain',
      component: channelMain,
      name: 'channelMain',
      meta: {
        keepAlive: true,
        menuId: 'parkMain/channelMain'
      }
    },
    {
      path: '/parkingLockMain',
      component: parkingLockMain,
      name: 'parkingLockMain',
      meta: {
        keepAlive: true,
        menuId: 'parkMain/parkingLockMain'
      }
    },
    {
      path: '/parkingGeoMain',
      component: parkingGeoMain,
      name: 'parkingGeoMain',
      meta: {
        keepAlive: true,
        menuId: 'parkMain/parkingGeoMain'
      }
    },
    {
      path: '/parkDevCamMain',
      component: parkDevCamMain,
      name: 'parkDevCamMain',
      meta: {
        keepAlive: true,
        menuId: 'parkMain/parkDevCamMain'
      }
    },
    {
      path: '/ehallCardTimeoutMain',
      component: ehallCardTimeoutMain,
      name: 'ehallCardTimeoutMain',
      meta: {
        keepAlive: true,
        menuId: 'parkMain/ehallCardTimeoutMain'
      }
    },
    {
      path: '/filterPlateCodeMain',
      component: filterPlateCodeMain,
      name: 'filterPlateCodeMain',
      meta: {
        keepAlive: true,
        menuId: 'parkMain/filterPlateCodeMain'
      }
    },
    {
      path: '/roadSideParkMain',
      component: roadSideParkMain,
      name: 'roadSideParkMain',
      meta: {
        keepAlive: true,
        menuId: 'parkMain/roadSideParkMain'
      }
    },
    {
      path: '/pdaMain',
      component: pdaMain,
      name: 'pdaMain',
      meta: {
        keepAlive: true,
        menuId: 'parkMain/pdaMain'
      }
    },
    {
      path: '/parkPlace',
      component: parkPlace,
      name: 'parkPlace',
      meta: {
        keepAlive: true,
        menuId: 'parkMain/parkPlace'
      }
    },
    {
      path: '/arrMain',
      component: arrMain,
      name: 'arrMain',
      meta: {
        keepAlive: true,
        menuId: 'parkMain/arrMain'
      }
    },
    {
      path: '/nbiotMain',
      component: nbiotMain,
      name: 'nbiotMain',
      meta: {
        keepAlive: true,
        menuId: 'parkMain/nbiotMain'
      }
    },
    {
      path: '/ledMain',
      component: ledMain,
      name: 'ledMain',
      meta: {
        keepAlive: true,
        menuId: 'parkMain/ledMain'
      }
    },
    {
      path: '/rateMain',
      component: rateMain,
      name: 'rateMain',
      meta: {
        keepAlive: true,
        menuId: 'rateMain/rateMain'
      }
    },
    {
      path: '/tempRateMain',
      component: tempRateMain,
      name: 'tempRateMain',
      meta: {
        keepAlive: true,
        menuId: 'rateMain/tempRateMain'
      }
    },
    {
      path: '/holidayMain',
      component: holidayMain,
      name: 'holidayMain',
      meta: {
        keepAlive: true,
        menuId: 'rateMain/holidayMain'
      }
    },
    {
      path: '/cardMain',
      component: cardMain,
      name: 'cardMain',
      meta: {
        keepAlive: true,
        menuId: 'cardMain/cardMain'
      }
    },
    {
      path: '/customizedCardMain',
      component: customizedCardMain,
      name: 'customizedCardMain',
      meta: {
        keepAlive: true,
        menuId: 'cardMain/customizedCardMain'
      }
    },
    {
      path: '/cardConcentrateMain',
      component: cardConcentrateMain,
      name: 'cardConcentrateMain',
      meta: {
        keepAlive: true,
        menuId: 'cardConcentrateMain/cardConcentrateMain'
      }
    },
    {
      path: '/monthCardMain',
      component: monthCardMain,
      name: 'monthCardMain',
      meta: {
        keepAlive: true,
        menuId: 'monthCardMain/monthCardMain'
      }
    },
    {
      path: '/fuDanEhallCard',
      component: fuDanEhallCard,
      name: 'fuDanEhallCard',
      meta: {
        keepAlive: true,
        menuId: 'cardMain/fuDanEhallCard'
      }
    },
    {
      path: '/reportingVehicles',
      component: reportingVehicles,
      name: 'reportingVehicles',
      meta: {
        keepAlive: true,
        menuId: 'cardMain/reportingVehicles'
      }
    },
    {
      path: '/PlatCardGroup',
      component: PlatCardGroup,
      name: 'PlatCardGroup',
      meta: {
        keepAlive: true,
        menuId: 'cardMain/PlatCardGroup'
      }
    },
    {
      path: '/cardMainHis',
      component: cardMainHis,
      name: 'cardMainHis',
      meta: {
        keepAlive: true,
        menuId: 'cardMainHis/cardMainHis'
      }
    },
    {
      path: '/cardFeeMain',
      component: cardFeeMain,
      name: 'cardFeeMain',
      meta: {
        keepAlive: true,
        menuId: 'cardMain/cardFeeMain'
      }
    },
    {
      path: '/cardGroupMain',
      component: cardGroupMain,
      name: 'cardGroupMain',
      meta: {
        keepAlive: true,
        menuId: 'cardMain/cardGroupMain'
      }
    },
    {
      path: '/blackPlateMain',
      component: blackPlateMain,
      name: 'blackPlateMain',
      meta: {
        keepAlive: true,
        menuId: 'cardMain/blackPlateMain'
      }
    },
    {
      path: '/deploymentMain',
      component: deploymentMain,
      name: 'deploymentMain',
      meta: {
        keepAlive: true,
        menuId: 'cardMain/deploymentMain'
      }
    },
    {
      path: '/parkReserveList',
      component: parkReserveList,
      name: 'parkReserveList',
      meta: {
        keepAlive: true,
        menuId: 'cardMain/parkReserveList'
      }
    },
    {
      path: '/ISVReg',
      component: ISVReg,
      name: 'ISVReg',
      meta: {
        keepAlive: true,
        menuId: 'setting/ISVReg'
      }
    },
    {
      path: '/Login',
      component: Login,
      name: 'Login',
      meta: {
        keepAlive: false
      }
    },
    {
      path: '/ETCErrorPayDataList',
      component: ETCErrorPayDataList,
      name: 'ETCErrorPayDataList',
      meta: {
        keepAlive: false
      }
    },
    {
      path: '/cloudSeatData',
      component: cloudSeatData,
      name: 'cloudSeatData',
      meta: {
        keepAlive: true,
        menuId: 'report/cloudSeatData'
      }
    },
    {
      path: '/paymentChannelList',
      component: paymentChannelList,
      name: 'paymentChannelList',
      meta: {
        keepAlive: true,
        menuId: 'report/paymentChannelList'
      }
    },
    {
      path: '/couPurPayList',
      component: couPurPayList,
      name: 'couPurPayList',
      meta: {
        keepAlive: true,
        menuId: 'report/couPurPayList'
      }
    },
    {
      path: '/pasOrOutVehicleStatisticsList',
      component: pasOrOutVehicleStatisticsList,
      name: 'pasOrOutVehicleStatisticsList',
      meta: {
        keepAlive: true,
        menuId: 'report/pasOrOutVehicleStatisticsList'
      }
    },
    {
      path: '/shAppUploadList',
      component: shAppUploadList,
      name: 'shAppUploadList',
      meta: {
        keepAlive: true,
        menuId: 'report/shAppUploadList'
      }
    },
    {
      path: '/bgMobDetail',
      component: bgMobDetail,
      name: 'bgMobDetail',
      meta: {
        keepAlive: true,
        menuId: 'report/bgMobDetail'
      }
    },
    {
      path: '/bgChargePreExeReport',
      component: bgChargePreExeReport,
      name: 'bgChargePreExeReport',
      meta: {
        keepAlive: true,
        menuId: 'report/bgChargePreExeReport'
      }
    },
    {
      path: '/bgMobPassWork',
      component: bgMobPassWork,
      name: 'bgMobPassWork',
      meta: {
        keepAlive: true,
        menuId: 'report/bgMobPassWork'
      }
    },
    {
      path: '/bgCardMobDetail',
      component: bgCardMobDetail,
      name: 'bgCardMobDetail',
      meta: {
        keepAlive: true,
        menuId: 'report/bgCardMobDetail'
      }
    },
    {
      path: '/bgCardChargeReport',
      component: bgCardChargeReport,
      name: 'bgCardChargeReport',
      meta: {
        keepAlive: true,
        menuId: 'report/bgCardChargeReport'
      }
    },
    {
      path: '/bgCashPaymentDetail',
      component: bgCashPaymentDetail,
      name: 'bgCashPaymentDetail',
      meta: {
        keepAlive: true,
        menuId: 'report/bgCashPaymentDetail'
      }
    },
    {
      path: '/bgDayMobPassWork',
      component: bgDayMobPassWork,
      name: 'bgDayMobPassWork',
      meta: {
        keepAlive: true,
        menuId: 'report/bgDayMobPassWork'
      }
    },
    {
      path: '/bgMonMobPassWork',
      component: bgMonMobPassWork,
      name: 'bgMonMobPassWork',
      meta: {
        keepAlive: true,
        menuId: 'report/bgMonMobPassWork'
      }
    },
    {
      path: '*',
      hidden: true,
      name: '*',
      component: NotFound
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js